import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { endCall, startCall, setUserData, setCallDirection } from '../app-context/caller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

type Props = {
    onStart?: Function;
    user?: any;
};

const CallButton = (props: Props) => {
    const dispatch = useDispatch();
    const callStarted = useSelector((state: any) => state.call.value);

    const emptyFunc = () => {}

    const closePopUp = () => {
        dispatch(endCall())
    }

    const onCall = (e: any) => {
        dispatch(setUserData(props.user));
        dispatch(setCallDirection({direction:'שיחה יוצאת'}));
        if (props.onStart) {
            props.onStart(e);
        }
    }


    return (
        <>
        <div className='pointer' onClick={(e: any)=>onCall(e)}><FontAwesomeIcon icon={faPhone} /></div>
        </>
    )
}


export default CallButton;